import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  vehicle_info_heading: {
    id: 'towingRecord.summaryBody.vehicleInfoHeading',
    defaultMessage: 'Ajoneuvotiedot',
  },
  traficom_info_link: {
    id: 'towingRecord.summaryBody.traficomInfoLink',
    defaultMessage: 'ATJ-tiedot',
  },
  orderer_heading: {
    id: 'towingRecord.summaryBody.ordererHeading',
    defaultMessage: 'Tilaaja',
  },
  from_heading: {
    id: 'towingRecord.summaryBody.fromHeading',
    defaultMessage: 'Mistä',
  },
  to_heading: {
    id: 'towingRecord.summaryBody.toHeading',
    defaultMessage: 'Mihin',
  },
  repair_shop_fallback: {
    id: 'towingRecord.summaryBody.repairShopFallback',
    defaultMessage: 'Jos työ muuttuu hinaukseksi:',
  },
  additional_info_heading: {
    id: 'towingRecord.summaryBody.additionalInfoHeading',
    defaultMessage: 'Lisäselvitykset',
  },
  notes_heading: {
    id: 'towingRecord.summaryBody.notesHeading',
    defaultMessage: 'Muistiinpanot',
  },
  images_heading: {
    id: 'towingRecord.summaryBody.imagesHeading',
    defaultMessage: 'Kuvat',
  },
  images_added: {
    id: 'towingRecord.summaryBody.imagesAdded',
    defaultMessage: 'Lisättyjä kuvia ({count})',
  },
  no_images_added: {
    id: 'towingRecord.summaryBody.noImagesAdded',
    defaultMessage: 'Ei lisättyjä kuvia',
  },
})
